import { ApiResponse } from '../../ApiResponse';
import client from '../client';

interface Response extends ApiResponse<boolean> {}

interface RequestBody {
  username?: string;
  email?: string;
}

export const checkUserExists = async (
  username?: string,
  email?: string
): Promise<boolean> => {
  try {
    const data = await client.post<RequestBody, Response>('/user/exists', {
      username,
      email,
    });

    if (data.data === undefined) {
      throw new Error('API Error');
    }

    return data.data;
  } catch (e) {
    //TODO error handle
  }

  throw Error('Could not check username.');
};
